import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import { editStyles } from "./styles";

class CreateDigital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        ...this.props.data,
      },
    };
  }

  handleChange = (event) => {
    let { data } = this.state;
    let name = event.target.name;
    let value = event.target.value;
    if (event.target.type === "checkbox") {
      value = event.target.checked ? 1 : 0;
    }
    data[name] = value;
    this.setState({ data });
  };

  handleSubmit = async () => {
    let { data } = this.state;
    this.loading.startLoading();
    let check = await this.props.update(data);
    this.loading.stopLoading();
    this.props.finishUpdate(check);
  };
  render() {
    const { t, classes } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <InputFormat
                required
                label={t("digital_signal_create_title")}
                name="title"
                value={data.title}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("digital_signal_create_description")}
                name="description"
                value={data.description}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.isActive === 1 ? true : false}
                    name="isActive"
                    onChange={this.handleChange}
                  />
                }
                className={classes.label}
                label={t("digital_signal_create_is_active")}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12}>
              <MediaUpload media={data.media} onRef={(media) => (this.uploadMedia = media)} />
            </Grid> */}

            <Grid container item xs={12} sm={12} justify="flex-end">
              <Button
                variant={"contained"}
                color={"primary"}
                onClick={this.handleSubmit}
              >
                {t("digital_signal_update")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}
CreateDigital.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});
const mapDispatch = (dispatch) => ({
  update: dispatch.digitalSignal.update,
  getList: dispatch.digitalSignal.getList,
});
export default translate("translations")(
  withStyles(editStyles, { withTheme: true })(
    connect(mapState, mapDispatch)(CreateDigital)
  )
);
